import { type FC, useMemo } from "react";

import { Tooltip } from "@snapchat/snap-design-system";

import { formatNumbers } from "../../../../lens-stats/formatters";
import { Flexbox } from "../../../../shared/components";
import { optimizeHorizontalBarWidth } from "../../../formatters";
import { type CountriesStatsItem } from "../../../models";

import { barRow, horizontalBarChartValuePct } from "./HorizontalBarChartItem.module.css";
import { BarContainer, BarItem, KeyContainer, tooltipStyle } from "./HorizontalBarChartItem.styles";

interface HorizontalBarChartItem extends Omit<CountriesStatsItem, "key"> {
    country: string;
    valueClassName?: string;
}

export const HorizontalBarChartItem: FC<HorizontalBarChartItem> = ({ country, value, pct, width, valueClassName }) => {
    const { formattedValue, barWidth } = useMemo(
        () => ({
            formattedValue: formatNumbers(value),
            barWidth: optimizeHorizontalBarWidth(width),
        }),
        [value, width],
    );

    return (
        <BarContainer>
            <KeyContainer>{country}</KeyContainer>
            <Flexbox alignItems="center" justifyContent="space-between" className={barRow}>
                <Tooltip content={formattedValue} className={tooltipStyle}>
                    <BarItem width={barWidth} />
                </Tooltip>
                <span className={valueClassName ?? horizontalBarChartValuePct}>{pct}%</span>
            </Flexbox>
        </BarContainer>
    );
};
